/** @format */

import {Trans} from 'react-i18next';

import {
  Body,
  SuccessHeadline,
  SuccessIcon,
  SuccessTitle,
  SuccessDescription,
  Footer,
  CloseButton,
} from './styles';

interface Props {
  onClose: () => void;
}

const BankSentContent = ({onClose}: Props) => (
  <>
    <Body
      data-testid='bank-sent-content'
      sx={{gap: 4, padding: 2, minHeight: '230px', justifyContent: 'center'}}
    >
      <SuccessHeadline>
        <SuccessIcon component='span' className='material-symbols-outlined'>
          check_circle
        </SuccessIcon>
        <SuccessTitle>
          <Trans>Заявка принята</Trans>
        </SuccessTitle>
      </SuccessHeadline>
      <SuccessDescription>
        <Trans>Мы пришлем вам счет в ближайшее время</Trans>
      </SuccessDescription>
    </Body>
    <Footer>
      <CloseButton onClick={onClose} variant='contained'>
        <Trans>Закрыть</Trans>
      </CloseButton>
    </Footer>
  </>
);

export default BankSentContent;
